import {Component, Input, OnInit} from '@angular/core';
import {stringIsSet} from "../../providers/service/global-variables.service";

@Component({
    selector: 'app-box-project',
    templateUrl: './box-project.component.html',
    styleUrls: ['./box-project.component.scss'],
    standalone: false
})
export class BoxProjectComponent implements OnInit {

    @Input()
    public name: string | undefined;
    @Input()
    public referenceName: string | undefined;
    @Input()
    public image: any;
    @Input()
    public logo: any;
    @Input()
    public sigla: string = '';
    @Input()

    isNewProject: boolean = false;
    public loading: boolean = false;

    constructor() {
    }

    ngOnInit(): void {
        if (!stringIsSet(this.sigla) && stringIsSet(this.name)) {
            this.sigla = this.name.substring(0, 3).toUpperCase();
        }
        this.loading = true;
    }


    public resizeText() {
        if (this.sigla.length < 3) {
            return null;

        } else if (this.sigla.length > 3 && this.sigla.length < 6) {
            return 10 + 'px';
        } else {
            this.sigla = this.sigla.substring(0, 5);
            return 10 + 'px';
        }
    }

    // cambia il colore di sfondo nel caso di new project
    public get backGroundColor() {
        const color = (this.isNewProject) ? '#ffc60099' : '#5dbed7';
        return color;
    }

}
